import axios from '@/utils/request'

export default {
  getYouMayAlsoLikeList: (params) => axios({ url: '/api/product/mayLike/mayLike', method: 'GET', params }), // 猜你喜欢列表
  getYouMayAlsoLikeListBySpu: (data) => axios({ url: '/api/product/productBySpus', method: 'POST', data }), // 根据SPU查询猜你喜欢商品信息
  addYouMayAlsoLikeListGoods: (data) => axios({ url: '/api/product/mayLike/mayLike', method: 'POST', data }), // 添加猜你喜欢商品
  inspectSpuIsExactness: (data) => axios({ url: '/api/product/mayLike/checkProduct', method: 'POST', data }) // 校验spu是否正确
}
